import './App.css';
import Header from './Components/Header';
import Home from './Pages/Home';
import Footer from './Components/Footer';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import CheckLoanEligibility from "./Pages/CheckLoanEligibility";
import BecomeAPartner from './Pages/BecomeAPartner';
import Blog from './Pages/Blog';
import ReferEarn from './Pages/ReferEarn';
import AbroadScholarships from './Pages/AbroadScholarships';
import Overview from './Pages/Overview';
import Act from './Pages/Exams/Act';
import Pte from './Pages/Exams/Pte';
import Ielts from './Pages/Exams/Ielts';
import Toefl from './Pages/Exams/Toefl';
import Gre from './Pages/Exams/Gre';
import Sat from './Pages/Exams/Sat';
import Countries from './Pages/Countries/BestCountriesToStudyAbroad';
import Usa from './Pages/Countries/Usa';
import Uk from './Pages/Countries/Uk';
import Canada from './Pages/Countries/Canada';
import Australia from './Pages/Countries/Australia';
import France from './Pages/Countries/France';
import Germany from './Pages/Countries/Germany';
import Ireland from './Pages/Countries/Ireland';
import NewZealand from './Pages/Countries/NewZealand';
import About from './Pages/About';
import AbroadEducationLaonOverview from './Pages/AbroadEduationLoanOverview';
import InterestRates from './Pages/InterestRates';
import EducationLoanEmiCalculator from './Pages/EducationLoanEmiCalculator';
import Faq from './Pages/Faq';
import StudentTestimonials from './Pages/StudentTestimonials';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import TermCondition from './Pages/TermCondition';
import Mis from './Pages/Courses/Mis';
import MaterialScience from './Pages/Courses/MaterialScience';
import FinancialEngineering from './Pages/Courses/FinancialEngineering';
import MechanicalEngineering from './Pages/Courses/MechanicalEngineering';
import EnvironmentalEngineering from './Pages/Courses/EnvironmentalEngineering';
import DataScience from './Pages/Courses/DataScience';
import EngineeringMgmt from './Pages/Courses/EngineeringMgmt';
import ElectricalEngineering from './Pages/Courses/ElectricalEngineering';
import ComputerScience from './Pages/Courses/ComputerScience';
import AerospaceEngineering from './Pages/Courses/AerospaceEngineering';
import ChemicalEngineering from './Pages/Courses/ChemicalEngineering';
import BiomedicalEngineering from './Pages/Courses/BiomedicalEngineering';
import BusinessAnalytics from './Pages/Courses/BusinessAnalytics';
import CivilEngineering from './Pages/Courses/CivilEngineering';
import BioEngineering from './Pages/Courses/BioEngineering';
import AuxiloLendingPartner from './Pages/LendingPartner/AuxiloLendingPartner';
import AvanseLendingPartner from './Pages/LendingPartner/AvanseLendingPartner';
import AxisBankLendingPartner from './Pages/LendingPartner/AxisBankLendingPartner';
import BobLendingPartner from './Pages/LendingPartner/BobLendingPartner';
import IciciBankLendingPartner from './Pages/LendingPartner/IciciBankLendingPartner';
import IdfcFirstLendingPartner from './Pages/LendingPartner/IdfcFirstLendingPartner';
import InCredLendingPartner from './Pages/LendingPartner/InCredLendingPartner';
import HdfcCredilaLendingPartner from './Pages/LendingPartner/HdfcCredilaLendingPartner';
import MpowerFinancingLendingPartner from './Pages/LendingPartner/MpowerFinancingLendingPartner';
import ProdigyFinanceLendingPartner from './Pages/LendingPartner/ProdigyFinanceLendingPartner';
import SbiLendingPartner from './Pages/LendingPartner/SbiLendingPartner';
import TataCapitalLendingPartner from './Pages/LendingPartner/TataCapitalLendingPartner';
import UbiEducationLendingPartner from './Pages/LendingPartner/UbiEducationLendingPartner';
import { Engineering } from '@mui/icons-material';
import BlogDescription from './Pages/BlogDescription';
import BlogDescriptionTwo from './Pages/BlogDescriptionTwo';
import BlogDescriptionThree from './Pages/BlogDescriptionThree';
import Courses from './Pages/Courses/Courses';

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/become-a-partner" element={<BecomeAPartner />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/abroad-education-loan-overview" element={<AbroadEducationLaonOverview />} />
        <Route path="/auxilo-lending-partner" element={<AuxiloLendingPartner />} />
        <Route path="/avanse-lending-partner" element={<AvanseLendingPartner />} />
        <Route path="/axis-bank-lending-partner" element={<AxisBankLendingPartner />} />
        <Route path="/bob-lending-partner" element={<BobLendingPartner />} />
        <Route path="/icici-bank-lending-partner" element={<IciciBankLendingPartner />} />
        <Route path="/idfc-first-lending-partner" element={<IdfcFirstLendingPartner />} />
        <Route path="/incred-lending-partner" element={<InCredLendingPartner />} />
        <Route path="/hdfc-credila-lending-partner" element={<HdfcCredilaLendingPartner />} />
        <Route path="/mpower-financing-lending-partner" element={<MpowerFinancingLendingPartner />} />
        <Route path="/prodigy-finance-lending-partner" element={<ProdigyFinanceLendingPartner />} />
        <Route path="/sbi-lending-partner" element={<SbiLendingPartner />} />
        <Route path="/tata-capital-lending-partner" element={<TataCapitalLendingPartner />} />
        <Route path="/ubi-education-lending-partner" element={<UbiEducationLendingPartner />} />
        <Route path="/interest-rates" element={<InterestRates />} />
        <Route path="/education-loan-emi-calculator" element={<EducationLoanEmiCalculator />} />
        <Route path="/check-loan-eligibility" element={<CheckLoanEligibility />} />
        <Route path="/overview" element={<Overview />} />
        <Route path="/mis" element={<Mis />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/masters-in-materials-science" element={<MaterialScience />} />
        <Route path="/masters-in-mechanical-engineering" element={<MechanicalEngineering />} />
        <Route path="/masters-in-financial-engineering" element={<FinancialEngineering />} />
        <Route path="/masters-in-environmental-engineering" element={<EnvironmentalEngineering />} />
        <Route path="/master-in-data-science" element={<DataScience />} />
        <Route path="/masters-of-engineering-management" element={<EngineeringMgmt />} />
        <Route path="/masters-in-electrical-engineering" element={<ElectricalEngineering />} />
        <Route path="/master-in-computer-science" element={<ComputerScience />} />
        <Route path="/masters-in-aerospace-engineering" element={<AerospaceEngineering />} />
        <Route path="/masters-in-chemical-engineering" element={<ChemicalEngineering />} />
        <Route path="/masters-in-biomedical-engineering" element={<BiomedicalEngineering />} />
        <Route path="/masters-in-business-analytics" element={<BusinessAnalytics />} />
        <Route path="/masters-in-civil-engineering" element={<CivilEngineering />} />
        <Route path="/masters-in-bioengineering" element={<BioEngineering />} />
        <Route path="/best-countries-to-study-abroad" element={<Countries />} />
        <Route path="/usa" element={<Usa />} />
        <Route path="/uk" element={<Uk />} />
        <Route path="/canada" element={<Canada />} />
        <Route path="/australia" element={<Australia />} />
        <Route path="/france" element={<France />} />
        <Route path="/germany" element={<Germany />} />
        <Route path="/ireland" element={<Ireland />} />
        <Route path="/new-zealand" element={<NewZealand />} />
        <Route path="/act" element={<Act />} />
        <Route path="/pte" element={<Pte />} />
        <Route path="/sat" element={<Sat />} />
        <Route path="/gre" element={<Gre />} />
        <Route path="/toefl" element={<Toefl />} />
        <Route path="/ielts" element={<Ielts />} />
        <Route path="/abroad-scholarships" element={<AbroadScholarships />} />
        <Route path="/refer-earn" element={<ReferEarn />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blogdescription" element={<BlogDescription />} />
        <Route path="/blogdescriptionTwo" element={<BlogDescriptionTwo />} />
        <Route path="/blogdescriptionThree" element={<BlogDescriptionThree />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermCondition />} />
        <Route path="/student-testimonials" element={<StudentTestimonials />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
